/* Modal de bienvenida.

   Tarea 29 (fallas F2 y F4 del QA del 2026-09-10). Medido: el dialogo se abria
   solo con showModal() a los 1,800 ms en TODA ruta, incluidas la ficha y /cart.
   Mientras estaba abierto, elementFromPoint sobre el centro de #pdp-add
   devolvia DIALOG#depot-welcome y el clic de "Agregar al carrito" no llegaba al
   boton: el primer toque del cliente se gastaba en cerrar el modal.

   Correccion, en dos reglas:
   1. Solo la portada lo abre sola. En ficha, coleccion, carrito, busqueda,
      cuenta y checkout no aparece solo; el cliente lo abre con la pestana
      "Tu primer 10%", que sigue funcionando en todas las rutas.
   2. Si el cliente ya toco la pagina antes de que venza el temporizador, no se
      abre: nadie pierde un toque a la mitad de una compra.

   Tarea 62 agrega la regla 3, comentada abajo junto al codigo: en la portada
   tampoco se abre solo mientras el boton de la maquina 3D este a la vista.

   Lo demas (foco atrapado, cierre por backdrop, una sola vez por sesion y el
   alta en Klaviyo) queda igual. */
(()=>{
  const dialog=document.querySelector('#depot-welcome');
  if(!dialog||typeof dialog.showModal!=='function')return;
  const trigger=document.querySelector('[data-welcome-open]');
  const key='sd-welcome-session-v5';
  let opener=trigger;
  const remember=()=>{try{sessionStorage.setItem(key,'seen');}catch{}};
  const open=(element=trigger)=>{if(dialog.open)return;opener=element;dialog.showModal();remember();};
  const close=()=>dialog.close();
  trigger?.addEventListener('click',()=>open(trigger));
  dialog.querySelectorAll('[data-welcome-close]').forEach(button=>button.addEventListener('click',close));
  dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();});
  dialog.addEventListener('keydown',event=>{if(event.key!=='Tab')return;const items=[...dialog.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),[tabindex="0"]')].filter(e=>e.getClientRects().length);const first=items[0],last=items.at(-1);if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}});
  dialog.addEventListener('close',()=>{remember();if(opener)opener.focus({preventScroll:true});});
  const form=dialog.querySelector('[data-klaviyo-signup]');
  if(form){
    const button=form.querySelector('[type=submit]'),error=form.querySelector('[data-welcome-errors]');
    let busy=false;button.disabled=false;
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(busy||!form.reportValidity())return;
      busy=true;button.disabled=true;error.hidden=true;button.textContent='Registrando…';
      try{
        const {subscribeEmail}=await import(form.dataset.transportUrl);
        await subscribeEmail({email:form.elements.email.value.trim(),siteId:form.dataset.siteId,listId:form.dataset.listId,pagePath:location.pathname,consent:form.elements.email_consent.checked});
        form.querySelector('[data-welcome-fields]').hidden=true;
        const result=form.querySelector('[data-welcome-result]');
        form.querySelector('[data-welcome-result-message]').textContent=form.dataset.optIn==='double_opt_in'?'Recibimos tu solicitud. Revisa tu correo y confirma la suscripción para recibir nuestras novedades. Aquí tienes tu código de bienvenida:':'Recibimos tu solicitud de suscripción. Aquí tienes tu código de bienvenida:';
        result.hidden=false;result.focus();
      }catch(_){error.textContent='No pudimos registrar tu suscripción. Revisa tu conexión e intenta de nuevo.';error.hidden=false;}
      finally{busy=false;button.disabled=false;button.textContent='Quiero mi 10% ↗';}
    });
  }
  // Rutas donde el cliente esta comprando: el modal nunca se abre solo.
  // Carlos 2026-09-15: el modal tambien se abre solo en colecciones (ahi llega la pauta). Ficha, carrito y checkout siguen protegidos.
  const RUTAS_DE_COMPRA=['/cart','/checkout','/checkouts','/products','/search','/account','/orders','/apps'];
  const raiz=(window.Shopify?.routes?.root||'/');
  const ruta=location.pathname;
  const relativa=ruta.startsWith(raiz)?ruta.slice(raiz.length-1):ruta;
  const enCompra=RUTAS_DE_COMPRA.some(p=>relativa===p||relativa.startsWith(p+'/'));
  const esPortada=!enCompra&&(relativa===''||relativa==='/');
  const esColeccion=!enCompra&&relativa.startsWith('/collections/');

  /* Carlos 2026-09-15 (decision de producto que dejo abierta la tarea 62): se cambia "ya interactuo" por una ventana
     de 1.5 s desde el ultimo toque, para que en movil el modal si salga despues del scroll sin robar un toque a medias. */
  let ultimoToque=0;
  ['pointerdown','keydown'].forEach(evento=>addEventListener(evento,()=>{ultimoToque=Date.now();},{passive:true}));

  /* Tarea 62 (pendiente 3 de ux-ui, tarea 51). Medido por ux-ui: en la portada
     el heroe tiene el boton #open-machine, que abre la maquina 3D. showModal()
     pinta un ::backdrop que se traga el toque, y Playwright no lograba hacer
     clic en ese boton hasta cerrar el modal. La regla 1 de arriba no alcanza:
     la portada es justo la ruta donde el modal si se abre solo.

     Regla nueva, que solo agrega restricciones y no afloja ninguna de la
     tarea 29: en la portada el modal no se abre solo mientras el heroe que
     contiene el boton de la maquina siga a la vista, ni mientras el explorador
     3D este abierto. Cuando el heroe sale de pantalla por scroll se reevalua, y
     ahi siguen valiendo las dos condiciones viejas: nada de abrirse si el
     cliente ya toco la pagina, nada de abrirse encima de otro dialogo.

     Se vigila el heroe (.cinematic-hero) y no el boton suelto porque a 390 px
     el boton nace por debajo del pliegue: medido en esta corrida, con la
     referencia puesta en el boton el modal se abria igual y el clic seguia
     bloqueado. El heroe si ocupa la primera pantalla, asi que vigilarlo es lo
     que de verdad protege el toque sobre el boton.

     Consecuencia que hay que saber, medida y no escondida: en movil el scroll
     con el dedo dispara pointerdown, o sea marca "ya interactuo", asi que en la
     practica el modal casi no se abrira solo en la portada movil. La pestana
     "Tu primer 10%" sigue en toda ruta y sigue siendo la via de captacion.
     Si marca o Carlos quieren que el modal si aparezca tras el scroll, es una
     decision de producto: se cambia la condicion de interactuo por una ventana
     de tiempo desde el ultimo toque. Aqui no se decide por cuenta propia. */
  const botonMaquina=()=>document.getElementById('open-machine');
  const zonaProtegida=()=>{const b=botonMaquina();return b?(b.closest('.cinematic-hero')||b):null;};
  const exploradorAbierto=()=>{const e=document.getElementById('machine-explorer');return !!e&&!e.hidden;};
  const aLaVista=el=>{
    if(!el||!el.getClientRects().length)return false;
    const r=el.getBoundingClientRect();
    return r.bottom>0&&r.right>0&&r.top<(window.innerHeight||0)&&r.left<(window.innerWidth||0);
  };
  let vigilante=null;
  const intentarAbrir=()=>{
    if(dialog.open)return;
    if(Date.now()-ultimoToque<1500){setTimeout(intentarAbrir,1600);return;}
    if(document.querySelector('dialog[open]'))return;
    if(document.documentElement.classList.contains('sdc-abierto'))return;  // 2 oct: carrito lateral abierto, no tapar el boton Pagar
    if(exploradorAbierto())return;               // el 3D manda: no se le encima nada
    const zona=zonaProtegida();
    if(aLaVista(zona)){                          // esperar a que salga de pantalla
      if(vigilante||typeof IntersectionObserver!=='function')return;
      vigilante=new IntersectionObserver(entradas=>{
        if(entradas.some(e=>e.isIntersecting))return;
        vigilante.disconnect();vigilante=null;intentarAbrir();
      });
      vigilante.observe(zona);
      return;
    }
    open();
  };

  let seen=false;try{seen=sessionStorage.getItem(key)==='seen';}catch{}
  // director-diseno 09-18 (rec 4, aprobada por Carlos): nunca en la primera página de la sesión.
  let vistas=0;try{vistas=(+sessionStorage.getItem('sd-vistas')||0)+1;sessionStorage.setItem('sd-vistas',String(vistas));}catch{}
  /* Carlos 2026-10-02 (vio en Clarity que el modal le salió a alguien al ir a agregar un producto):
     ya no se abre solo a mitad de la navegación. Solo la PRIMERA vez que la persona entra a la tienda
     (en este navegador): aparece sin bloquear la página (show, sin fondo oscuro), dura 3 s y se cierra
     solo, salvo que la persona lo esté usando. Después queda una barra delgada arriba para abrirlo. */
  const VISTO='sd-10-primera-vez';
  let primera=false;try{primera=!localStorage.getItem(VISTO);localStorage.setItem(VISTO,'1');}catch{primera=!seen&&vistas===1;}
  if(!enCompra){
    const barra=document.createElement('button');
    barra.type='button';barra.className='sd-barra-10';
    barra.innerHTML='¿Primera compra? <b>10%<span class="sd-b10-l"> de descuento</span></b> desde $555 <u>Quiero mi 10%</u>';
    barra.addEventListener('click',()=>open(barra));
    document.body.prepend(barra);
  }
  // 3 oct (Carlos aprobó la auditoría): un solo 10%. La ventana ya no se abre sola, ni la primera vez; solo al tocar la barra, con showModal (encima de todo).
})();


/* Tarea 64, defecto 2 del hallazgo de la tarea 59. Respaldo sin :has() para la
   barra de envio gratis: assets/sd-shipping-progress.js pone data-ver="1" en
   #sd-envio cuando el carrito trae algo, y aqui se refleja en una clase del
   <body> que assets/sd-v5-welcome.css si puede leer sin :has(). Solo lee el
   DOM, no toca el carrito ni la barra. */
(()=>{
  const barra=document.getElementById('sd-envio');
  if(!barra)return;
  const marcar=()=>{
    const visible=barra.getAttribute('data-ver')==='1';
    document.body.classList.toggle('sd-envio-visible',visible);
    document.body.style.setProperty('--sd-envio-alto',(visible?barra.offsetHeight:0)+'px');
  };
  marcar();
  new MutationObserver(marcar).observe(barra,{attributes:true,attributeFilter:['data-ver']});
  addEventListener('resize',marcar,{passive:true});
})();

/* 2 oct: barra delgada del 10% arriba de todo */
(()=>{const s=document.createElement('style');s.textContent='.sd-barra-10{display:block;width:100%;margin:0;border:0;border-bottom:1px solid #3A2C17;background:#1A140C;color:#E9DCC9;font:500 13px/1.3 system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;padding:8px 14px;text-align:center;cursor:pointer}.sd-barra-10 b{color:#E2A04A}.sd-barra-10 u{color:#E2A04A;margin-left:6px;white-space:nowrap}@media(max-width:600px){.sd-barra-10{white-space:nowrap;padding:7px 10px;font-size:12.5px}.sd-b10-l{display:none}}';document.head.appendChild(s);})();
